import { v4 as uuid } from 'uuid';

export const FieldTypes = {
  SHORT_TEXT: 'SHORT_TEXT',
  LONG_TEXT: 'LONG_TEXT',
  EMAIL: 'EMAIL',
  NUMBER: 'NUMBER',
  DATE: 'DATE',
  MONEY: 'MONEY',
  AMOUNT: 'AMOUNT',
  LGA: 'LGA',
  STATE: 'STATE',
  MULTIPLE_CHOICE: 'MULTIPLE_CHOICE',
  DROP_DOWN: 'DROP_DOWN',
  DOCUMENT: 'DOCUMENT',
  IMAGE: 'IMAGE',
  BASIC_DETAILS: 'BASIC_DETAILS',
  EXTRA_DETAILS: 'EXTRA_DETAILS',
  PHONE_NUMBER: 'PHONE_NUMBER',
  OTHER_NUMBER: 'OTHER_NUMBER',
};

export const chartData = [
  {
    name: 'Jan',
    uv: 2500,
    pv: 2400,
    amt: 2400,
  },
  {
    name: 'Feb',
    uv: 3000,
    pv: 1398,
    amt: 2210,
  },
  {
    name: 'Mar',
    uv: 2000,
    pv: 9800,
    amt: 2290,
  },
  {
    name: 'Apr',
    uv: 2780,
    pv: 3908,
    amt: 2000,
  },
  {
    name: 'May',
    uv: 1890,
    pv: 4800,
    amt: 2181,
  },
  {
    name: 'Jun',
    uv: 2390,
    pv: 3800,
    amt: 2500,
  },
  {
    name: 'Jul',
    uv: 3490,
    pv: 4300,
    amt: 2100,
  },
  {
    name: 'Aug',
    uv: 2780,
    pv: 3908,
    amt: 2000,
  },
  {
    name: 'Sep',
    uv: 1890,
    pv: 4800,
    amt: 2181,
  },
  {
    name: 'Oct',
    uv: 2390,
    pv: 3800,
    amt: 2500,
  },
  {
    name: 'Nov',
    uv: 3490,
    pv: 4300,
    amt: 2100,
  },
  {
    name: 'Dec',
    uv: 4400,
    pv: 4300,
    amt: 2100,
  },
];

export const lgaFileId = '2';

export const terminalLog = [
  {
    id: '2EI399KJE',
    number: '91201005991897',
    label: 'Ikeja store',
    date: new Date(),
    transactionCount: 0,
  },
];

export const terminalDetailsLog = [
  {
    id: 'KUD001',
    description: 'Ikeja-COLLECTI-8D583-c55fa68d-961...',
    amount: 230234,
    date: new Date(),
    status: 'SUCCESS',
  },
  {
    id: 'KUD001',
    description: 'Ikeja-COLLECTI-8D583-c55fa68d-961...',
    amount: 230234,
    date: new Date(),
    status: 'SUCCESS',
  },
  {
    id: 'KUD001',
    description: 'Ikeja-COLLECTI-8D583-c55fa68d-961...',
    amount: 230234,
    date: new Date(),
    status: 'SUCCESS',
  },
  {
    id: 'KUD001',
    description: 'Ikeja-COLLECTI-8D583-c55fa68d-961...',
    amount: 230234,
    date: new Date(),
    status: 'SUCCESS',
  },
  {
    id: 'KUD001',
    description: 'Ikeja-COLLECTI-8D583-c55fa68d-961...',
    amount: 230234,
    date: new Date(),
    status: 'SUCCESS',
  },
  {
    id: 'KUD001',
    description: 'Ikeja-COLLECTI-8D583-c55fa68d-961...',
    amount: 230234,
    date: new Date(),
    status: 'SUCCESS',
  },
  {
    id: 'KUD001',
    description: 'Ikeja-COLLECTI-8D583-c55fa68d-961...',
    amount: 230234,
    date: new Date(),
    status: 'SUCCESS',
  },
  {
    id: 'KUD001',
    description: 'Ikeja-COLLECTI-8D583-c55fa68d-961...',
    amount: 230234,
    date: new Date(),
    status: 'SUCCESS',
  },
];

export const terminalRequestListing = [
  {
    name: 'Terminal name goes here',
    quantity: '2',
    amount: 46500,
    date: new Date(),
  },
  {
    name: 'Terminal name goes here',
    quantity: '2',
    amount: 46500,
    date: new Date(),
  },
  {
    name: 'Terminal name goes here',
    quantity: '2',
    amount: 46500,
    date: new Date(),
  },
  {
    name: 'Terminal name goes here',
    quantity: '2',
    amount: 46500,
    date: new Date(),
  },
];

export const terminalData = [
  {
    id: uuid(),
    name: 'Kudi Terminal',
    price: '₦20,000',
    amount: 20000,
    description: `You can now collect payment via Kudi. Order for a Kudi Terminal, and add your delivery details. It will be delivered to you in less than 7 working days. Thanks for choosing Kudi.`,
    count: 0,
  },
];

export const transactionDetailSample = {
  id: 1323,
  amount: 2000,
  agentId: '67acd19d-010a-4767-b2bd-47d5f8790a93',
  longitude: 3.5319438,
  latitude: 6.4481109,
  agentCommission: 60,
  revenue: 1900,
  commission: 40,
  productCode: 'AMF2116D',
  product: {
    id: 1291,
    code: 'AMF2116D',
    title: 'Bimm2',
    description:
      'At Bimms insurance we offer life insurance and secure you from any harm',
    amount: 2000,
    amountType: 'DYNAMIC',
    properties: null,
    merchantId: 35,
    merchantBusinessName: 'Amazon',
    merchantCode: 'AMF2',
    imageUrl:
      'https://drake.kudi.ng/images/8d4403d3-e18b-47b9-ac38-5427eaf18cd3?size=orig',
    extraField: null,
    status: 'ACTIVE',
    createdAt: '2021-10-04T19:51:19Z',
    phone: null,
    amountPropertyId: 2690,
    displayOnApp: true,
    totalCollections: 0,
    totalRevenue: null,
    totalAmountCollected: null,
    pricing: null,
    paymentCallbackUrl: '',
    lookupUrl: null,
    category: null,
    businessSector: {
      id: 4,
      name: 'Insurance',
      nameSlugified: 'insurance',
      status: 'ACTIVE',
    },
  },
  merchantId: 35,
  productName: 'Bimm2',
  parentReference: null,
  billingVendorReference: null,
  paymentVendorReference: null,
  status: 'PENDING',
  properties: {
    AMF2116D2686: ['AMF2116DSUB2687'],
    AMF2116D2685: '09073355894',
    AMF2116D2690: 2000,
  },
  meta: {
    'Country of residence': '[NIGERIA]',
    Amount: '2000',
    'Phone Number': '09073355894',
  },
  merchantNotificationStatus: 'PROCESSING',
  createdAt: '2021-12-14T11:40:57.355248Z',
};
